// Flip, ScrollTrigger, Observer, ScrollToPlugin, Draggable, MotionPathPlugin, CustomEase,
// DrawSVGPlugin, ScrollSmoother, GSDevTools, InertiaPlugin, MorphSVGPlugin, MotionPathHelper,
// SplitText, CustomBounce, CustomWiggle,
import { gsap, ScrollTrigger } from "gsap/all";

gsap.registerPlugin(ScrollTrigger);
export default () => {
  let mm = gsap.matchMedia();
  //------------------------------------------------------//
  // Setup 🧦 GSAP and register 📜 ScrollTrigger
  // Register more plugins like so: gsap.registerPlugin(ScrollTrigger, splitText);
  // Go to https://greensock.com/docs/v3/Installation?checked=core,scrollTrigger,splitText#installer
  //------------------------------------------------------//
  // gsap.registerPlugin(Flip, ScrollTrigger, Observer, ScrollToPlugin, Draggable, MotionPathPlugin, CustomEase, DrawSVGPlugin, ScrollSmoother, GSDevTools, InertiaPlugin, MorphSVGPlugin, MotionPathHelper, SplitText, CustomBounce, CustomWiggle);

  ScrollTrigger.defaults({
    toggleActions: "restart pause resume pause",
    markers: window.location.hostname.endsWith(".local") ? true : false,
  });

  // END Setup 🧦 GSAP -------------------------------------//

  // Each block uses its own mm.add() so media queries (and future toggles) stay independent.

  //------------------------------------------------------//
  // Header ornaments
  //------------------------------------------------------//
  mm.add("(min-width: 992px)", () => {
    document.querySelectorAll('.header-ornaments').forEach((container, index) => {
      const q = gsap.utils.selector(container);
      const y = gsap.utils.wrap([-250, -150]);
      const origin = gsap.utils.wrap(["center left", "center right"]);
      const tl = gsap.timeline({
        defaults: {
          ease: 'none',
        },
        scrollTrigger: {
          id: `header-ornament-${index}`,
          trigger: "body",
          start: "top top",
          endTrigger: "#alloy-header",
          end: "bottom top",
          scrub: true,

        }
      });
      tl.from(q('.ornament'), {
        transformOrigin: (index) => origin(index),
        y: (index) => y(index),
        scaleY: 3,
        scaleX: 2,
        ease: 'power2.inOut',
      });
      if (document.querySelector('#alloy-header .image img')) {
        tl.to('#alloy-header .image img', {
          scale: 1.1,
        }, "<");
      }
    });
  });
  // END Header ornaments -------------------------------------//

  //--------------------------------//
  // Card Y animation
  //--------------------------------//
  mm.add("(min-width: 992px)", () => {
    document.querySelectorAll('.has-cards-animation-y .overview').forEach((container, index) => {
      const q = gsap.utils.selector(container);
      const maxMove = 300;
      const tl = gsap.timeline({
        defaults: {
          ease: 'none',
        },
        scrollTrigger: {
          id: `card-y-animation-${index}`,
          trigger: container,
          start: "top bottom",
          end: "top center-=10%",
          scrub: true,
        },
      });
      const amount = q('.animate').length;
      const move = gsap.utils.mapRange(0, amount, maxMove, 10);
      tl.from(q('.animate'), {
        y: (index) => move(index),
      });
    });
  });
  // END Card Y animation --------------//

  //--------------------------------//
  // Card X animation
  //--------------------------------//
  mm.add("(min-width: 992px)", () => {
    document.querySelectorAll('.has-cards-animation-x .animate-cards-x').forEach((container, index) => {
      const q = gsap.utils.selector(container);
      const maxMove = 300;
      const tl = gsap.timeline({
        defaults: {
          ease: 'none',
        },
        scrollTrigger: {
          id: `card-x-animation-${index}`,
          trigger: container,
          start: "top bottom",
          end: "top center-=10%",
          scrub: true,
        },
      });
      const amount = q('.animate').length;
      const move = gsap.utils.mapRange(0, amount, 10, maxMove);
      tl.from(q('.animate'), {
        x: (index) => move(index),
      });
    });
  });
  // END Card X animation --------------//

  //--------------------------------//
  // 📌 Pin container
  //--------------------------------//
  mm.add("(min-width: 992px)", () => {
    document.querySelectorAll('.alloy-pin-container')
      .forEach(function (container) {
        if (container.querySelector('.alloy-sidebar')) {
          const item = container.querySelector('.extra');
          const height = item.querySelector('.size').offsetHeight + 100;
          // console.warn(height);
          const timeline = gsap.timeline({
            scrollTrigger: {
              trigger: container,
              scrub: 0.5,
              start: 'top-=50px top',
              end: `bottom ${height}px`,
              pin: item,
              pinSpacing: false,
            }
          });
        }
      });
  });
  // END 📌 Pin container --------------//
};
